import { useT } from "@/app/hooks/useT";
import GxBlackButtonSmall from "../../components/common/actions/buttons/GxBlackButtonSmall";
import { DATA_GIF_PATH } from "../../utils/config";
import { useQueryParam } from "@/app/hooks/useQueryParam";

interface SuccessModalSMProp {
  onClose: () => void;
  isOpen: boolean;
  successData?: any;
  successMessage?: string;
  bulkApproveCount?: string;
  isConsentSuccess?: boolean;
  isConsentFailed?: boolean;
}
const SuccessModalSM = ({
  isOpen,
  onClose,
  successData,
  successMessage,
  bulkApproveCount,
  isConsentSuccess,
  isConsentFailed,
}: Readonly<SuccessModalSMProp>) => {
  const t = useT();
  const status = successData?.aprdStatus;
  const message = useQueryParam("message");
  const showSuccessGif =
    status === "A" ||
    status === "SR" ||
    bulkApproveCount ||
    isConsentSuccess ||
    status === "consent";

  const showRejectGif =
    status === "R" ||
    status === "F" ||
    status === "TF" ||
    isConsentFailed;

  let descriptionMessage: string | null = null;

  if (status === "A") {
    if (successMessage === "Approved"||(successData?.noOfApprovalrequired===successData?.aprdLevel)) {
      descriptionMessage = t("the_transaction_has_been_successfully_approved");
    } else {
      descriptionMessage = t("once_all_the_approvals_are_completed");
    }
  } else if (status === "R") {
    descriptionMessage = t("the_transaction_has_been_successfully_rejected");
  }

  if (!isOpen) return null;

  const renderAnimation = () => {
    if (showSuccessGif) {
      return (
        <img
          src={`${DATA_GIF_PATH}done_animation.gif`}
          alt="Success"
          className="gx-success-animation"
        />
      );
    }

    if (showRejectGif) {
      return (
        <img
          src={`${DATA_GIF_PATH}reject_animation.gif`}
          alt="Rejected"
          className="gx-success-animation"
        />
      );
    }

    return null;
  };

  const renderMainMessage = () => {
    if (status === "SR") {
      return (
        <>
          {t("repair_request")} <br />
          <span className="gx-font-bold">{t("sent")}!</span>
        </>
      );
    }

    if (status === "A") {
      if (successMessage === "Approved") {
        return (
          <>
            {t("transaction_approved")} <br />
            <span className="gx-font-bold">{t("successfully")}!</span>
          </>
        );
      }

      return (
        <>
          {t("transaction_approved")} <br />
          <span className="gx-font-bold">{t("by_you")}</span>
        </>
      );
    }

    if (status === "R") {
      return (
        <>
          {t("transaction_rejected")} <br />
          <span className="gx-font-bold">{t("successfully")}</span>
        </>
      );
    }

    if (status === "F") {
      return (
        <>
          {"Transaction Approve"} <br />
          <span className="gx-font-bold">{"Failed"}</span>
        </>
      );
    }

    if (status === "TF" && message) {
      const messageArray = message?.split(" ");
      const lastWord = messageArray[messageArray?.length - 1];
      messageArray?.pop();
      return (
        <>
          {messageArray.join(" ")} <br />
          <span className="gx-font-bold">{lastWord}</span>
        </>
      );
    }

    if (bulkApproveCount) {
      return (
        <>
          {t("payment_approved")} <br />
          <span className="gx-font-bold">{t("successfully")}</span>
        </>
      );
    }

    if (status === "consent") {
      return (
        <>
          {"Consent Re-Submitted"} <br />
          <span className="gx-font-bold">{t("successfully")}</span>
        </>
      );
    }

    return null;
  };

  return (
    <div className="gx-custom-remark-modal-background-t">
      <div className="gx-custom-remark-modal-conatiner">
        <div className={`gx-custom-remark-modal ${isOpen ? "show" : "hide"}`}>
          <main className="gx-custom-remark-modal-main">
            <div className="gx-animation-wrapper-s">{renderAnimation()}</div>
            <div className="flex justify-center">
              <span
                className={`gx-message gx-font-regular ${status === "TF" ? "gx-message-top-space" : ""}`}
              >
                {renderMainMessage()}
              </span>
            </div>
            <div className="gx-description-wrapper ">
              {successData?.aprdStatus === "SR" ? (
                <p className="gx-font-medium gx-msg-description-text">
                  {t("the_transaction_has_been_successfully_sent")}
                </p>
              ) : (
                descriptionMessage && (
                  <p className="gx-font-medium gx-msg-description-text">
                    {descriptionMessage}
                  </p>
                )
              )}
              {bulkApproveCount && (
                <p className="gx-font-medium gx-msg-description-text">
                  {t("approval_status")}:
                  <span className="gx-font-bold"> {bulkApproveCount}</span>
                </p>
              )}
              {isConsentSuccess && (
                <p className="text-[#4d4d4d] text-[1rem] gx-font-medium text-center ">
                  {t("your_consent_has_been_successfully_authorized")}
                </p>
              )}
            </div>
          </main>
          <footer className="gx-custom-remark-modal-footer">
            <div className="space-x-4">
              <GxBlackButtonSmall onClick={onClose}>
                {t("ok")}
              </GxBlackButtonSmall>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default SuccessModalSM;
